let API_BASE = "/api";
export class VideoConstants {
  public static VIDEO_LIST = API_BASE + "/video/videos";

  public static VIDEO_COLLECTION_CREATE = API_BASE + "/video/collection";
  public static VIDEO_CREATE = API_BASE + "/video/videos";
  public static VIDEO_FETCH = API_BASE + "/video/videos/{videoId}";
}
